import React from 'react';
import { Controller, UseFormReturn } from 'react-hook-form';
import { FirmSettingsDTO } from '../../api/useFirmSettingsQuery';
import { SectionHeader } from '../SectionHeader/SectionHeader';
import { Row } from '../../../../../CommonComponents/OPL/Grid/Row';
import { Column } from '../../../../../CommonComponents/OPL/Grid/Column';
import { Select } from '../../../../../CommonComponents/OPL/Select/Select/Select';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { MarginProps } from '../../../../../theme/styledProps';
import { SettingsGrid } from '../SettingsGrid/SettingsGrid';
import { FormValues } from '../../FirmSettings.meta';

interface Props extends MarginProps {
  formBag: UseFormReturn<FormValues>;
  options: FirmSettingsDTO['clientLandingPageOptions'];
}

export const LandingPage: React.FC<Props> = ({ formBag, options, ...rest }) => {
  return (
    <Box as="section" {...rest}>
      <SectionHeader title="Client Portal Landing Page" />

      <SettingsGrid>
        <Row>
          <Column width={4}>
            <Controller
              control={formBag.control}
              name="clientLandingPage"
              render={({ field: { value } }) => (
                <Select
                  value={options.find(({ value: _value }) => value === _value)}
                  options={options}
                  onChange={opt => {
                    if (opt) {
                      formBag.setValue('clientLandingPage', opt.value, { shouldDirty: true });
                    }
                  }}
                />
              )}
            />
          </Column>
        </Row>
      </SettingsGrid>
    </Box>
  );
};
